import React from 'react';
import { TabValues, chartUnits } from '../DeviceDetails/constants';

const CustomLegend = ({ payload, chartType }) => {
    if (chartType.title === TabValues.All) {
        const visible = payload.filter((entry) => entry.value !== '__tooltipAnchor');
        return (
            <ul className="flex flex-wrap gap-2 md:justify-between items-center w-full h-full">
                {visible.map((entry, index) => {
                    const textColor = { color: entry.color };
                    return (
                        <li key={`item-${index}`}>
                            <h6
                                className="text-sm font-medium"
                                style={textColor}
                            >
                                - {entry.value}
                            </h6>
                        </li>
                    );
                })}
            </ul>
        );
    }

    return (
        <h5 className="font-medium text-left">
            {chartUnits[chartType.title] || '...'}
        </h5>
    );
};

export default CustomLegend;
